<template>
  <el-drawer
    title="Facturas Vencidas"
    :visible="DriwerVisible"
    size="50%"
    append-to-body
    @close="Onclose"
  >
    <el-row>
      <el-col>
        <rabbey-table-3
          ref="table"
          :loading="TableLoading"
          :columns="columns"
          :data="Items"
        ></rabbey-table-3>
      </el-col>
    </el-row>
  </el-drawer>
</template>

<script>
export default {
  name: "FacturasVencidasGps",
  props: {
    visible: {
      typeof: Boolean,
      default: false
    },
    Client: {
      typeof: String,
      default: ""
    }
  },

  data() {
    return {
      Items: [],
      TableLoading: false,
      DriwerVisible: false,
      columns: [
        {
          prop: "Cliente",
          label: "Codigo Cliente",
          sortable: true,
          width: 170,
          fixed: true
        },
        {
          prop: "Factura",
          label: "# Factura",
          sortable: true,
          width: 190,
          fixed: true
        },
        {
          prop: "Monto",
          label: "Monto Pendiente",
          sortable: true,
          width: 190,
          fixed: true
        },
        {
          prop: "Descripcion",
          label: "Descripcion",
          width: 240,
          fixed: true
        },
        {
          prop: "Fecha",
          label: "Fecha Vencimiento",
          sortable: true,
          width: 260,
          fixed: true
        }
      ]
    };
  },

  methods: {
    async GetData(Client) {
      this.TableLoading = true;
      await this.$http
        .get(
          `/api/customers/GetFacturasPendienteByClient?Cliente='${Client}'`,
          {
            timeout: 3 * 60 * 1000
          }
        )
        .then(({ data }) => {
          this.Items = data.Facturas;
          this.TableLoading = false;
        });
    },

    Onclose() {
      this.DriwerVisible = false;
      this.$emit("CloseFacturas", false);
    }
  },

  watch: {
    async visible(newValue) {
      if (newValue) {
        await this.GetData(this.Client);
        this.DriwerVisible = newValue;
      }
    }
  }
};
</script>
